import styled from "styled-components";
import { LOGO_LG } from "@assets";
import { Space } from "antd";
import { BackOutlined } from '@assets';

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background: linear-gradient(
    180deg,
    rgba(74, 14, 68, 1) 15%,
    rgba(30, 23, 47, 1) 60%
  );
  padding: 0px 29px;

  .ant-btn-primary {
    width: 170px;
    height: 52px;
    border-radius: 26px !important;
    text-align: center;
    margin-bottom: 8px;
  }
`;

export const Logo = styled.img.attrs({
  alt: "logo",
  src: LOGO_LG,
})`
  width: 180px;
  height: auto;
  object-fit: contain;
  padding-top: 35px;
`;

export const Container = styled.div`
  margin-top: 35px;
  margin-bottom: 45px;
`;

export const Title = styled.div`
  margin-bottom: 34px;
  font-size: 18px;
  color: #fff;
  text-align: center;
  text-transform: capitalize;
`;

export const StyledInput = styled.input`
  width: 40px !important;
  height: 40px !important;
  border-radius: 5px !important;
  text-align: center !important;
  border: 1px solid ${(props) => (props.status === "error" ? "red" : "#E1CCE0")} !important;
  font-size: 17px !important;
  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  @media screen and (max-width: 380px) {
    width: 30px !important;
    height: 30px !important;
  }
  @media screen and (max-width: 320px) {
    width: 25px !important;
    height: 25px !important;
  }
`;

export const BottomBox = styled(Space)`
  width: 100%;
  margin-top: 16px;

  .ant-space-item:nth-child(1) {
    flex: 1;
  }
`;

export const BottomText = styled.div`
  margin-left: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #ecb2e9;
  text-align: left;
  cursor: pointer;
`;

export const TimeText = styled.div`
  margin-right: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
`;

export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 32px;
`;

export const BackIcon = styled(BackOutlined)`
  font-size: 24px;
  color: #fff;
  cursor: pointer;
`;